import React, { useEffect, useCallback } from "react";
import AuthContainer from "core/modules/auth";
import { getToken } from "helpers/TokenHelper";
import { useDispatch } from "react-redux";
import { changeAvatar, logIn } from "core/modules/auth/loginSlice";
import { useAsonikaSelector } from "app/redux/hooks";
import { getCorrectFormatAvatar } from "features/userProfile/api";
import { UserAuthorizeGet } from "entities/generated/back/data-contracts";
import { apiLogon } from "app/axios";

const AuthCheck = (props: any) => {
  const isAuth = useAsonikaSelector((store) => store.user.isAuth);
  const dispatch = useDispatch();
  const loginAction = useCallback(
    (user: UserAuthorizeGet) => dispatch(logIn(user)),
    [dispatch]
  );
  useEffect(() => {
    (async () => {
      var accToken = getToken();
      if (accToken) {
        apiLogon
          .getMyUser({})
          .then(async (response) => {
            const user = response.data as UserAuthorizeGet;
            if (user && accToken) {
              user.jwtToken = accToken;
              loginAction(response.data);
              if (user.id) {
                const imgBase64 = await getCorrectFormatAvatar(user.id);
                dispatch(changeAvatar(imgBase64));
              }
            }
          })
          .catch();
      }
    })();
  }, []);
  const { children } = props;
  if (isAuth) {
    return children;
  } else {
    return <AuthContainer />;
  }
};

export default AuthCheck;
